import { Box } from '@chakra-ui/react';
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { useOfferStore } from '../store';
import { NewTemplatesForm } from './offer-template/TemplatesForm';
import { AttachmentContainer } from './AttachmentContainer';
import { useShowToast } from '@/hooks/useShowToast';

export const OfferLetterTemplate = forwardRef(function OfferLetterTemplate(
  props: any,
  comRef: any
) {
  const {
    initialValues = {},
    detailsFormRef,
    detailsFormConfig,
    currentOffer,
    onTemplateSelect,
    currentStepID,
    initialDepartmentId,
    initialOfficeId,
    sendMode = false,
    existingFormValues = {},
  } = props;
  const toast = useShowToast();
  const isPolling = useOfferStore((state) => state.isPolling);

  const templatesFormRef = useRef(null);
  const [templateProps, setTemplateProps] = useState({
    selected_template_id: null,
    template_value: {},
  });

  useImperativeHandle(comRef, () => ({
    getModel: () => {
      const hasValidData = !!templateProps?.selected_template_id && !isPolling;

      if (!templateProps?.selected_template_id) {
        toast({
          title: 'Please select offer letter template to continue',
          status: 'error',
        });
      }

      const templatePayload = {
        ats_offer_template_id: templateProps?.selected_template_id,
        ats_offer_template: templateProps?.template_value || {},
      };

      return {
        hasValidData,
        payload: templatePayload,
      };
    },
  }));

  if (currentStepID !== 'offerLetterTemplate') {
    return null;
  }

  return (
    <Box ref={comRef} h="100%" w="100%" position="relative">
      <NewTemplatesForm
        initialValues={{ templates: initialValues }}
        templatesFormRef={templatesFormRef}
        detailsFormRef={detailsFormRef}
        tabIndex={1}
        currentOffer={currentOffer}
        detailsFormConfig={detailsFormConfig}
        templateProps={templateProps}
        setTemplateProps={setTemplateProps}
        onTemplateSelect={onTemplateSelect}
        initialDepartmentId={initialDepartmentId}
        initialOfficeId={initialOfficeId}
        sendMode={sendMode}
        existingFormValues={existingFormValues}
      />
      <AttachmentContainer
        offerId={currentOffer?.id}
        currentOffer={currentOffer}
      />
    </Box>
  );
});
